// ================= BASIC_SETTING_DETAILS =================== //
export const BASIC_SETTING_DETAILS = "BASIC_SETTING_DETAILS";
export const BASIC_SETTING_DETAILS_SUCCESS = "BASIC_SETTING_DETAILS_SUCCESS";
export const BASIC_SETTING_DETAILS_FAIL = "BASIC_SETTING_DETAILS_FAIL";

// ================= GET_CONFIG_DETAILS =================== //
export const GET_BASIC_DETAILS = "GET_BASIC_DETAILS";
export const GET_BASIC_DETAILS_SUCCESS = "GET_BASIC_DETAILS_SUCCESS";
export const GET_BASIC_DETAILS_FAIL = "GET_BASIC_DETAILS_FAIL";

// ================= CHANGE PASS OTP =================== //
export const CHANGE_PASS_OTP = "CHANGE_PASS_OTP";
export const CHANGE_PASS_OTP_SUCCESS = "CHANGE_PASS_OTP_SUCCESS";
export const CHANGE_PASS_OTP_FAIL = "CHANGE_PASS_OTP_FAIL";

// ================= CHANGE PASS OTP VERIFY =================== //
export const CHANGE_PASS_OTP_VERIFY = "CHANGE_PASS_OTP_VERIFY";
export const CHANGE_PASS_OTP_VERIFY_SUCCESS = "CHANGE_PASS_OTP_VERIFY_SUCCESS";
export const CHANGE_PASS_OTP_VERIFY_FAIL = "CHANGE_PASS_OTP_VERIFY_FAIL";

// ================= CHANGE PASS ADMIN =================== //
export const CHANGE_PASS_ADMIN = "CHANGE_PASS_ADMIN";
export const CHANGE_PASS_ADMIN_SUCCESS = "CHANGE_PASS_ADMIN_SUCCESS";
export const CHANGE_PASS_ADMIN_FAIL = "CHANGE_PASS_ADMIN_FAIL";
